import { ProjectTypes } from './project';
import { ServiceTypes, ServiceName } from './service-form';
import { NewsTypes } from './news';
import { AdminRoles } from './role';

export const defaultMenuType = 'menu-sub-hidden'; // 'menu-default', 'menu-sub-hidden', 'menu-hidden';

export const menuItems = [
  {
    id: 'homepage',
    icon: 'iconsminds-shop-4',
    label: '首頁管理',
    to: '#',
    subs: [
      {
        icon: 'simple-icon-rocket',
        label: '輪播管理',
        to: {
          name: 'banner-list',
        },
      },
      {
        icon: 'simple-icon-rocket',
        label: '熱銷建案',
        to: {
          name: 'project-spotlight',
          params: {
            projectType: ProjectTypes.SPOTLIGHT,
          },
        },
      },
      {
        icon: 'simple-icon-rocket',
        label: '最新消息',
        to: {
          name: 'news-spotlight',
          params: {
            newsType: NewsTypes.SPOTLIGHT,
          },
        },
      },
    ],
    roles: [AdminRoles.root, AdminRoles.admin, AdminRoles.editor],
  },
  {
    id: 'news',
    icon: 'iconsminds-digital-drawing',
    label: '新訊管理',
    to: '#',
    subs: [
      {
        icon: 'simple-icon-plane',
        label: '活動快訊',
        to: {
          name: 'news-list',
          params: {
            newsType: NewsTypes.LATEST,
          },
        },
      },
      {
        icon: 'simple-icon-plane',
        label: '公司動態',
        to: {
          name: 'news-list',
          params: {
            newsType: NewsTypes.COMPANY,
          },
        },
      },
    ],
    roles: [AdminRoles.root, AdminRoles.admin, AdminRoles.editor],
  },
  {
    id: 'progress',
    icon: 'iconsminds-air-balloon-1',
    label: '進度管理',
    to: '#',
    projectSub: {
      icon: 'simple-icon-layers',
      to: {
        name: 'progress-list',
      },
    },
    roles: [AdminRoles.root, AdminRoles.admin, AdminRoles.editor],
  },
  {
    id: 'service-form',
    icon: 'iconsminds-box-with-folders',
    label: '表單管理',
    to: '#',
    subs: [
      {
        icon: 'simple-icon-check',
        label: ServiceName.LAND,
        to: {
          name: 'service-list',
          params: {
            serviceType: ServiceTypes.LAND,
          },
        },
      },
      {
        icon: 'simple-icon-check',
        label: ServiceName.RESERVATION,
        to: {
          name: 'service-list',
          params: {
            serviceType: ServiceTypes.RESERVATION,
          },
        },
      },
      {
        icon: 'simple-icon-check',
        label: ServiceName.REPAIR,
        to: {
          name: 'service-list',
          params: {
            serviceType: ServiceTypes.REPAIR,
          },
        },
      },
      {
        icon: 'simple-icon-check',
        label: ServiceName.OTHER,
        to: {
          name: 'service-list',
          params: {
            serviceType: ServiceTypes.OTHER,
          },
        },
      },
    ],
    roles: [AdminRoles.root, AdminRoles.admin, AdminRoles.editor],
  },
  {
    id: 'resident',
    icon: 'iconsminds-support',
    label: '住戶管理',
    to: '#',
    projectSub: {
      icon: 'simple-icon-emotsmile',
      to: {
        name: 'resident-list',
      },
    },
  },
  {
    id: 'project',
    icon: 'iconsminds-building',
    label: '建案管理',
    to: '#',
    subs: [
      {
        icon: 'simple-icon-chart',
        label: '新建案列表',
        to: {
          name: 'project-list',
          params: {
            projectType: ProjectTypes.LASTEST,
          },
        },
      },
      {
        icon: 'simple-icon-chart',
        label: '舊建案列表',
        to: {
          name: 'project-list',
          params: {
            projectType: ProjectTypes.OUTDATED,
          },
        },
      },
      {
        icon: 'simple-icon-chart',
        label: '都更建案',
        to: {
          name: 'project-list',
          params: {
            projectType: ProjectTypes.URBAN,
          },
        },
      },
    ],
    roles: [AdminRoles.root, AdminRoles.admin, AdminRoles.editor],
  },
  {
    id: 'admin',
    icon: 'iconsminds-user',
    label: '帳號管理',
    to: {
      name: 'admin-list',
    },
    roles: [AdminRoles.root, AdminRoles.admin, AdminRoles.editor, AdminRoles.staff],
  },
];
